import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';

import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
var render = function render() {
  var _vm$formConfig$locati, _vm$listCountries, _vm$formConfig$produc, _vm$formConfig$bottli, _vm$formConfig$produc2, _vm$formConfig$locati2, _vm$listCountries2, _vm$formConfig$produc3, _vm$formConfig$bottli2, _vm$formConfig$produc4, _vm$formConfig$locati3, _vm$listCountries3, _vm$formConfig$produc5, _vm$formConfig$bottli3, _vm$formConfig$produc6;
  var _vm = this,
    _c = _vm._self._c;
  return _vm.isAuthorized ? _c("div", {
    staticClass: "content-centered large"
  }, [_c("div", {
    staticClass: "container-centered small-2"
  }, [_vm.exportingStatus == _vm.exportingStatusList.PREPARATION.id ? [_c(VForm, {
    staticClass: "form",
    model: {
      value: _vm.formConfig.valid,
      callback: function callback($$v) {
        _vm.$set(_vm.formConfig, "valid", $$v);
      },
      expression: "formConfig.valid"
    }
  }, [_vm.isAdminNotConsultant(_vm.loggedUserData) ? [_vm.isSpiritsExport ? _c("div", {
    staticClass: "mb-3"
  }, [_vm._v("Spirit Export Price List")]) : _vm._e(), _c("div", [_vm._v("Please select the target for the price list")]), _c("div", {
    staticClass: "filters-inline"
  }, [_c("div", [_c(VAutocomplete, {
    class: !!_vm.formConfig.userIdTarget ? "" : "required",
    attrs: {
      items: _vm.userBuyerGroups,
      "item-text": "name",
      "item-value": "id",
      label: "User group",
      "hide-details": "auto",
      filter: _vm.filterVAutocomplete,
      rules: _vm.formConfig.userIdTarget ? [] : [_vm.formRules.mustSelectValue],
      disabled: !!_vm.formConfig.userIdTarget,
      clearable: ""
    },
    model: {
      value: _vm.formConfig.userGroup,
      callback: function callback($$v) {
        _vm.$set(_vm.formConfig, "userGroup", $$v);
      },
      expression: "formConfig.userGroup"
    }
  }), _c(VAutocomplete, {
    class: !!_vm.formConfig.userIdTarget ? "" : "required",
    attrs: {
      items: _vm.implantedCountries,
      "item-text": "printable_name",
      "item-value": "id_country",
      label: "Delivery country",
      "hide-details": "auto",
      filter: _vm.filterVAutocomplete,
      rules: _vm.formConfig.userIdTarget ? [] : [_vm.formRules.mustSelectValue],
      disabled: !!_vm.formConfig.userIdTarget,
      clearable: ""
    },
    on: {
      change: _vm.applyCountryDefaultCurrency
    },
    model: {
      value: _vm.formConfig.countryId,
      callback: function callback($$v) {
        _vm.$set(_vm.formConfig, "countryId", $$v);
      },
      expression: "formConfig.countryId"
    }
  }), _vm.displayedListStates.length > 0 ? _c(VAutocomplete, {
    class: _vm.isStateRequired ? "required" : "",
    attrs: {
      items: _vm.displayedListStates,
      "item-text": "state_label",
      "item-value": "id_state",
      label: "Delivery state",
      "hide-details": "auto",
      filter: _vm.filterVAutocomplete,
      rules: _vm.isStateRequired ? [_vm.formRules.mustSelectValue] : [],
      disabled: !!_vm.formConfig.userIdTarget,
      clearable: ""
    },
    model: {
      value: _vm.formConfig.stateId,
      callback: function callback($$v) {
        _vm.$set(_vm.formConfig, "stateId", $$v);
      },
      expression: "formConfig.stateId"
    }
  }) : _vm._e()], 1), _c("div", [_vm._v("Or")]), _c("div", [_c(VAutocomplete, {
    class: !!_vm.formConfig.userGroup || _vm.formConfig.countryId ? "" : "required",
    attrs: {
      items: _vm.thirdPartyUserList,
      "item-text": "full_name",
      "item-value": "id_user",
      label: _vm.isLoadingUserList ? "Loading user list" : !!_vm.formConfig.userGroup || !!_vm.formConfig.countryId ? "Unselect user group and delivery country to unlock" : "Specific customer",
      "no-data-text": _vm.isLoadingUserList ? "Loading user list" : _vm.thirdPartyUserList.length < 1 ? "No user is attached to your account" : "No match",
      "hide-details": "auto",
      placeholder: _vm.isLoadingUserList ? "Loading users" : "Search for a specific customer",
      rules: !!_vm.formConfig.userGroup || _vm.formConfig.countryId ? [] : [_vm.formRules.mustSelectValue],
      filter: _vm.filterVAutocomplete,
      disabled: !!_vm.formConfig.userGroup || !!_vm.formConfig.countryId,
      clearable: ""
    },
    model: {
      value: _vm.formConfig.userIdTarget,
      callback: function callback($$v) {
        _vm.$set(_vm.formConfig, "userIdTarget", $$v);
      },
      expression: "formConfig.userIdTarget"
    }
  })], 1)]), _vm.canChooseCurrency ? _c(VAutocomplete, {
    attrs: {
      items: _vm.listDefaultCurrencies,
      "item-value": "id",
      "item-text": "name",
      label: "Currency",
      "hide-no-data": "",
      "hide-selected": ""
    },
    model: {
      value: _vm.formConfig.currency,
      callback: function callback($$v) {
        _vm.$set(_vm.formConfig, "currency", $$v);
      },
      expression: "formConfig.currency"
    }
  }) : _vm._e(), _vm.canChoosePricePosting ? _c(VAutocomplete, {
    staticClass: "required",
    attrs: {
      items: _vm.gettingPricePostingUsaProPosted.items,
      "item-value": "id",
      "item-text": "applicationDateString",
      label: _vm.isAdminNotConsultant(_vm.loggedUserData) ? "Price posting month" : "Estimated delivery month",
      rules: [_vm.formRules.mustSelectValueZeroOk],
      "hide-no-data": "",
      "hide-selected": ""
    },
    model: {
      value: _vm.formConfig.pricePostingUsaProId,
      callback: function callback($$v) {
        _vm.$set(_vm.formConfig, "pricePostingUsaProId", $$v);
      },
      expression: "formConfig.pricePostingUsaProId"
    }
  }) : _vm._e(), _c(VAutocomplete, {
    staticClass: "v-text-field-no-label mt-2 --not-multi-style",
    attrs: {
      items: _vm.storageLocations,
      "item-value": "ids",
      "item-text": "name",
      label: ((_vm$formConfig$locati = _vm.formConfig.locations) === null || _vm$formConfig$locati === void 0 ? void 0 : _vm$formConfig$locati.length) > 0 ? "Storage locations" : "All storage locations",
      "hide-details": "auto",
      "hide-no-data": "",
      "hide-selected": "",
      multiple: "",
      chips: "",
      "deletable-chips": "",
      clearable: ""
    },
    model: {
      value: _vm.formConfig.locations,
      callback: function callback($$v) {
        _vm.$set(_vm.formConfig, "locations", $$v);
      },
      expression: "formConfig.locations"
    }
  }), _c(VAutocomplete, {
    attrs: {
      items: _vm.listCountries,
      "item-text": "printable_name",
      "item-value": "id_country",
      label: ((_vm$listCountries = _vm.listCountries) === null || _vm$listCountries === void 0 ? void 0 : _vm$listCountries.length) > 0 ? "Country & region of origin" : "Loading...",
      "hide-details": "auto",
      "hide-no-data": "",
      "hide-selected": "",
      clearable: "",
      filter: _vm.filterVAutocomplete
    },
    on: {
      "click:clear": function clickClear($event) {
        _vm.options = {
          smoothScroll: false
        };
      },
      change: function change($event) {
        return _vm.changeCountry();
      }
    },
    model: {
      value: _vm.formConfig.originCountryId,
      callback: function callback($$v) {
        _vm.$set(_vm.formConfig, "originCountryId", $$v);
      },
      expression: "formConfig.originCountryId"
    }
  }), _vm.formConfig.originCountryId > 0 ? _c(VAutocomplete, {
    attrs: {
      items: _vm.displayedListRegions,
      "item-text": "name",
      "item-value": "id",
      label: "Region",
      "hide-details": "auto",
      "hide-no-data": "",
      "hide-selected": "",
      clearable: "",
      filter: _vm.filterVAutocomplete
    },
    on: {
      "click:clear": function clickClear($event) {
        _vm.options = {
          smoothScroll: false
        };
      },
      change: function change($event) {
        return _vm.changeRegion();
      }
    },
    model: {
      value: _vm.formConfig.originRegionId,
      callback: function callback($$v) {
        _vm.$set(_vm.formConfig, "originRegionId", $$v);
      },
      expression: "formConfig.originRegionId"
    }
  }) : _vm._e(), _c(VAutocomplete, {
    staticClass: "v-text-field-no-label mt-4 --not-multi-style",
    attrs: {
      items: _vm.displayedListProducers,
      disabled: _vm.isLoadingProducers,
      "item-value": "id",
      "item-text": "name",
      label: ((_vm$formConfig$produc = _vm.formConfig.producersId) === null || _vm$formConfig$produc === void 0 ? void 0 : _vm$formConfig$produc.length) > 0 ? "Producers" : "All producers",
      "hide-details": "auto",
      "hide-no-data": "",
      "hide-selected": "",
      clearable: "",
      multiple: "",
      chips: "",
      "deletable-chips": "",
      filter: _vm.filterVAutocomplete,
      "search-input": _vm.winerySearchInput
    },
    on: {
      "update:searchInput": function updateSearchInput($event) {
        _vm.winerySearchInput = $event;
      },
      "update:search-input": function updateSearchInput($event) {
        _vm.winerySearchInput = $event;
      },
      change: function change($event) {
        _vm.winerySearchInput = "";
      }
    },
    model: {
      value: _vm.formConfig.producersId,
      callback: function callback($$v) {
        _vm.$set(_vm.formConfig, "producersId", $$v);
      },
      expression: "formConfig.producersId"
    }
  }), _c(VAutocomplete, {
    staticClass: "v-text-field-no-label mt-4 --not-multi-style",
    attrs: {
      items: _vm.bottlings,
      "item-text": "text",
      "item-value": "value",
      label: ((_vm$formConfig$bottli = _vm.formConfig.bottlings) === null || _vm$formConfig$bottli === void 0 ? void 0 : _vm$formConfig$bottli.length) > 0 ? "Bottlings" : "All bottlings",
      "hide-details": "auto",
      "hide-no-data": "",
      "hide-selected": "",
      clearable: "",
      multiple: "",
      chips: "",
      "deletable-chips": "",
      filter: _vm.filterVAutocomplete
    },
    model: {
      value: _vm.formConfig.bottlings,
      callback: function callback($$v) {
        _vm.$set(_vm.formConfig, "bottlings", $$v);
      },
      expression: "formConfig.bottlings"
    }
  }), !_vm.isSpiritsExport ? _c(VAutocomplete, {
    staticClass: "v-text-field-no-label mt-4 --not-multi-style",
    attrs: {
      items: _vm.getWineTypes,
      "item-text": "name",
      "item-value": "id",
      label: ((_vm$formConfig$produc2 = _vm.formConfig.productTypesId) === null || _vm$formConfig$produc2 === void 0 ? void 0 : _vm$formConfig$produc2.length) > 0 ? "Types" : "All types",
      "hide-details": "auto",
      "hide-no-data": "",
      "hide-selected": "",
      clearable: "",
      multiple: "",
      chips: "",
      "deletable-chips": "",
      filter: _vm.filterVAutocomplete
    },
    model: {
      value: _vm.formConfig.productTypesId,
      callback: function callback($$v) {
        _vm.$set(_vm.formConfig, "productTypesId", $$v);
      },
      expression: "formConfig.productTypesId"
    }
  }) : _vm._e(), _vm.canChoosePricePosting ? _c("div", {
    staticClass: "d-flex gap-5 align-center"
  }, [_c("div", {
    staticClass: "d-flex align-baseline gap-2",
    staticStyle: {
      width: "100%"
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-greater-than-equal v-icon-price-range",
    attrs: {
      size: "0.65rem"
    }
  }), _c(VTextField, {
    attrs: {
      label: "Min price"
    },
    on: {
      keypress: _vm.filterDecimal2digitsKey
    },
    model: {
      value: _vm.formConfig.priceRange.min,
      callback: function callback($$v) {
        _vm.$set(_vm.formConfig.priceRange, "min", $$v);
      },
      expression: "formConfig.priceRange.min"
    }
  })], 1), _c("div", {
    staticClass: "d-flex align-baseline gap-2",
    staticStyle: {
      width: "100%"
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-less-than-equal v-icon-price-range",
    attrs: {
      size: "0.65rem"
    }
  }), _c(VTextField, {
    attrs: {
      label: "Max price"
    },
    on: {
      keypress: _vm.filterDecimal2digitsKey
    },
    model: {
      value: _vm.formConfig.priceRange.max,
      callback: function callback($$v) {
        _vm.$set(_vm.formConfig.priceRange, "max", $$v);
      },
      expression: "formConfig.priceRange.max"
    }
  })], 1)]) : _vm._e(), _c(VTextField, {
    staticClass: "v-text-field-no-label mt-4",
    attrs: {
      label: "Filtering, match at least one of term",
      "hide-details": "auto"
    },
    model: {
      value: _vm.formConfig.search,
      callback: function callback($$v) {
        _vm.$set(_vm.formConfig, "search", $$v);
      },
      expression: "formConfig.search"
    }
  }), _c(VCheckbox, {
    attrs: {
      label: "Available products only",
      "hide-details": "auto"
    },
    model: {
      value: _vm.formConfig.isStockOnly,
      callback: function callback($$v) {
        _vm.$set(_vm.formConfig, "isStockOnly", $$v);
      },
      expression: "formConfig.isStockOnly"
    }
  }), _c("div", {
    staticClass: "mt-3"
  }, [_c(VCheckbox, {
    staticClass: "mt-0",
    attrs: {
      label: "Add the WineId column, for import purpose",
      "hide-details": "auto"
    },
    model: {
      value: _vm.formConfig.isWineIdColumn,
      callback: function callback($$v) {
        _vm.$set(_vm.formConfig, "isWineIdColumn", $$v);
      },
      expression: "formConfig.isWineIdColumn"
    }
  }), _vm.canAddCogsColumn ? _c(VCheckbox, {
    staticClass: "mt-0",
    attrs: {
      label: "Add the COGS column",
      "hide-details": "auto"
    },
    model: {
      value: _vm.formConfig.isCogsColumn,
      callback: function callback($$v) {
        _vm.$set(_vm.formConfig, "isCogsColumn", $$v);
      },
      expression: "formConfig.isCogsColumn"
    }
  }) : _vm._e()], 1), _c("p", {
    staticClass: "mt-5 text-italic"
  }, [_vm._v(" The price list will be compatible for any customer with this configuration, not associated to a consultant. "), _c("br"), _vm._v(" Prices will include import and sales taxes. "), _c("br"), _vm._v(" * Except for french professionals, the prices will be exported without VAT * ")])] : _vm.isConsultantNotHolding(_vm.loggedUserData) ? [_vm.isLoadingUserList ? _c("div", {
    staticClass: "mb-6 text-italic text-sm"
  }, [_vm._v(" Loading required data. Please wait ")]) : !_vm.thirdPartyUserList.length ? _c("div", {
    staticClass: "mb-6"
  }, [_c("div", {
    staticClass: "text-warning text-bold"
  }, [_vm._v(" You do not yet have any customers to export a price list. ")]), _c("div", {
    staticClass: "button-end-page-container"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.openSendInvitationAsConsultantModal();
      }
    }
  }, [_vm._v(" Invite user(s) ")])], 1)]) : _vm._e(), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isLoadingUserList && _vm.thirdPartyUserList.length > 0,
      expression: "!isLoadingUserList && thirdPartyUserList.length > 0"
    }]
  }, [_c("div", [_vm._v("Please select the target for the price list")]), _c("div", {
    staticClass: "filters-inline"
  }, [_c("div", [_c(VAutocomplete, {
    class: !!_vm.formConfig.userGroup || _vm.formConfig.countryId ? [] : ["required"],
    attrs: {
      items: _vm.thirdPartyUserList,
      "item-text": "full_name",
      "item-value": "id_user",
      "hide-selected": "",
      "hide-no-data": "",
      "no-data-text": _vm.isLoadingUserList ? "Loading user list" : _vm.thirdPartyUserList.length < 1 ? "No user is attached to your account" : "No match",
      "hide-details": "auto",
      label: _vm.isLoadingUserList ? "Loading users" : "Search for a specific customer",
      rules: !!_vm.formConfig.userGroup || _vm.formConfig.countryId ? [] : [_vm.formRules.mustSelectValue],
      filter: _vm.filterVAutocomplete,
      disabled: !!_vm.formConfig.userGroup || !!_vm.formConfig.countryId,
      clearable: ""
    },
    model: {
      value: _vm.formConfig.userIdTarget,
      callback: function callback($$v) {
        _vm.$set(_vm.formConfig, "userIdTarget", $$v);
      },
      expression: "formConfig.userIdTarget"
    }
  })], 1), _c("div", {
    staticClass: "pb-1"
  }, [_vm._v("Or")]), _c("div", [_c(VAutocomplete, {
    class: !!_vm.formConfig.userIdTarget ? "" : "required",
    attrs: {
      items: _vm.userBuyerGroups,
      "item-text": "name",
      "item-value": "id",
      label: "User group",
      "hide-details": "auto",
      filter: _vm.filterVAutocomplete,
      rules: _vm.formConfig.userIdTarget ? [] : [_vm.formRules.mustSelectValue],
      disabled: !!_vm.formConfig.userIdTarget,
      clearable: ""
    },
    model: {
      value: _vm.formConfig.userGroup,
      callback: function callback($$v) {
        _vm.$set(_vm.formConfig, "userGroup", $$v);
      },
      expression: "formConfig.userGroup"
    }
  }), _c(VAutocomplete, {
    class: !!_vm.formConfig.userIdTarget ? "" : "required",
    attrs: {
      items: _vm.implantedCountriesForConsultant,
      "item-text": "printable_name",
      "item-value": "id_country",
      label: "Delivery country",
      "hide-details": "auto",
      filter: _vm.filterVAutocomplete,
      rules: _vm.formConfig.userIdTarget ? [] : [_vm.formRules.mustSelectValue],
      disabled: !!_vm.formConfig.userIdTarget,
      clearable: ""
    },
    on: {
      change: _vm.applyCountryDefaultCurrency
    },
    model: {
      value: _vm.formConfig.countryId,
      callback: function callback($$v) {
        _vm.$set(_vm.formConfig, "countryId", $$v);
      },
      expression: "formConfig.countryId"
    }
  }), _vm.displayedListStates.length > 0 ? _c(VAutocomplete, {
    class: _vm.isStateRequired ? "required" : "",
    attrs: {
      items: _vm.displayedListStates,
      "item-text": "state_label",
      "item-value": "id_state",
      label: "Delivery state",
      "hide-details": "auto",
      filter: _vm.filterVAutocomplete,
      rules: _vm.isStateRequired ? [_vm.formRules.mustSelectValue] : [],
      disabled: !!_vm.formConfig.userIdTarget,
      clearable: ""
    },
    model: {
      value: _vm.formConfig.stateId,
      callback: function callback($$v) {
        _vm.$set(_vm.formConfig, "stateId", $$v);
      },
      expression: "formConfig.stateId"
    }
  }) : _vm._e()], 1)]), _c(VAutocomplete, {
    staticClass: "v-text-field-no-label mt-2 --not-multi-style",
    attrs: {
      items: _vm.storageLocations,
      "item-value": "ids",
      "item-text": "name",
      label: ((_vm$formConfig$locati2 = _vm.formConfig.locations) === null || _vm$formConfig$locati2 === void 0 ? void 0 : _vm$formConfig$locati2.length) > 0 ? "Storage locations" : "All storage locations",
      "hide-details": "auto",
      "hide-no-data": "",
      "hide-selected": "",
      multiple: "",
      chips: "",
      "deletable-chips": "",
      clearable: ""
    },
    model: {
      value: _vm.formConfig.locations,
      callback: function callback($$v) {
        _vm.$set(_vm.formConfig, "locations", $$v);
      },
      expression: "formConfig.locations"
    }
  }), _c(VAutocomplete, {
    attrs: {
      items: _vm.listCountries,
      "item-text": "printable_name",
      "item-value": "id_country",
      label: ((_vm$listCountries2 = _vm.listCountries) === null || _vm$listCountries2 === void 0 ? void 0 : _vm$listCountries2.length) > 0 ? "Country & region of origin" : "Loading...",
      "hide-details": "auto",
      "hide-no-data": "",
      "hide-selected": "",
      clearable: "",
      filter: _vm.filterVAutocomplete
    },
    on: {
      "click:clear": function clickClear($event) {
        _vm.options = {
          smoothScroll: false
        };
      },
      change: function change($event) {
        return _vm.changeCountry();
      }
    },
    model: {
      value: _vm.formConfig.originCountryId,
      callback: function callback($$v) {
        _vm.$set(_vm.formConfig, "originCountryId", $$v);
      },
      expression: "formConfig.originCountryId"
    }
  }), _vm.formConfig.originCountryId > 0 ? _c(VAutocomplete, {
    attrs: {
      items: _vm.displayedListRegions,
      "item-text": "name",
      "item-value": "id",
      label: "Region",
      "hide-details": "auto",
      "hide-no-data": "",
      "hide-selected": "",
      clearable: "",
      filter: _vm.filterVAutocomplete
    },
    on: {
      "click:clear": function clickClear($event) {
        _vm.options = {
          smoothScroll: false
        };
      },
      change: function change($event) {
        return _vm.changeRegion();
      }
    },
    model: {
      value: _vm.formConfig.originRegionId,
      callback: function callback($$v) {
        _vm.$set(_vm.formConfig, "originRegionId", $$v);
      },
      expression: "formConfig.originRegionId"
    }
  }) : _vm._e(), _c(VAutocomplete, {
    staticClass: "v-text-field-no-label mt-4 --not-multi-style",
    attrs: {
      items: _vm.displayedListProducers,
      disabled: _vm.isLoadingProducers,
      "item-value": "id",
      "item-text": "name",
      label: ((_vm$formConfig$produc3 = _vm.formConfig.producersId) === null || _vm$formConfig$produc3 === void 0 ? void 0 : _vm$formConfig$produc3.length) > 0 ? "Producers" : "All producers",
      "hide-details": "auto",
      "hide-no-data": "",
      "hide-selected": "",
      clearable: "",
      multiple: "",
      chips: "",
      "deletable-chips": "",
      "search-input": _vm.winerySearchInput,
      filter: _vm.filterVAutocomplete
    },
    on: {
      "update:searchInput": function updateSearchInput($event) {
        _vm.winerySearchInput = $event;
      },
      "update:search-input": function updateSearchInput($event) {
        _vm.winerySearchInput = $event;
      },
      change: function change($event) {
        _vm.winerySearchInput = "";
      }
    },
    model: {
      value: _vm.formConfig.producersId,
      callback: function callback($$v) {
        _vm.$set(_vm.formConfig, "producersId", $$v);
      },
      expression: "formConfig.producersId"
    }
  }), _c(VAutocomplete, {
    staticClass: "v-text-field-no-label mt-4 --not-multi-style",
    attrs: {
      items: _vm.bottlings,
      "item-text": "text",
      "item-value": "value",
      label: ((_vm$formConfig$bottli2 = _vm.formConfig.bottlings) === null || _vm$formConfig$bottli2 === void 0 ? void 0 : _vm$formConfig$bottli2.length) > 0 ? "Bottlings" : "All bottlings",
      "hide-details": "auto",
      "hide-no-data": "",
      "hide-selected": "",
      clearable: "",
      multiple: "",
      chips: "",
      "deletable-chips": "",
      filter: _vm.filterVAutocomplete
    },
    model: {
      value: _vm.formConfig.bottlings,
      callback: function callback($$v) {
        _vm.$set(_vm.formConfig, "bottlings", $$v);
      },
      expression: "formConfig.bottlings"
    }
  }), !_vm.isSpiritsExport ? _c(VAutocomplete, {
    staticClass: "v-text-field-no-label mt-4 --not-multi-style",
    attrs: {
      items: _vm.getWineTypes,
      "item-text": "name",
      "item-value": "id",
      label: ((_vm$formConfig$produc4 = _vm.formConfig.productTypesId) === null || _vm$formConfig$produc4 === void 0 ? void 0 : _vm$formConfig$produc4.length) > 0 ? "Types" : "All types",
      "hide-details": "auto",
      "hide-no-data": "",
      "hide-selected": "",
      clearable: "",
      multiple: "",
      chips: "",
      "deletable-chips": "",
      filter: _vm.filterVAutocomplete
    },
    model: {
      value: _vm.formConfig.productTypesId,
      callback: function callback($$v) {
        _vm.$set(_vm.formConfig, "productTypesId", $$v);
      },
      expression: "formConfig.productTypesId"
    }
  }) : _vm._e(), _vm.canChoosePricePosting ? _c("div", {
    staticClass: "d-flex gap-5 align-center"
  }, [_c("div", {
    staticClass: "d-flex align-baseline gap-2"
  }, [_c(VIcon, {
    staticClass: "fa fa-greater-than-equal v-icon-price-range",
    attrs: {
      size: "0.65rem"
    }
  }), _c(VTextField, {
    attrs: {
      label: "Min price"
    },
    on: {
      keypress: _vm.filterDecimal2digitsKey
    },
    model: {
      value: _vm.formConfig.priceRange.min,
      callback: function callback($$v) {
        _vm.$set(_vm.formConfig.priceRange, "min", $$v);
      },
      expression: "formConfig.priceRange.min"
    }
  })], 1), _c("div", {
    staticClass: "d-flex align-baseline gap-2"
  }, [_c(VIcon, {
    staticClass: "fa fa-less-than-equal v-icon-price-range",
    attrs: {
      size: "0.65rem"
    }
  }), _c(VTextField, {
    attrs: {
      label: "Max price"
    },
    on: {
      keypress: _vm.filterDecimal2digitsKey
    },
    model: {
      value: _vm.formConfig.priceRange.max,
      callback: function callback($$v) {
        _vm.$set(_vm.formConfig.priceRange, "max", $$v);
      },
      expression: "formConfig.priceRange.max"
    }
  })], 1)]) : _vm._e(), _c(VTextField, {
    staticClass: "v-text-field-no-label mt-4",
    attrs: {
      label: "Filtering, match at least one of term",
      "hide-details": "auto"
    },
    model: {
      value: _vm.formConfig.search,
      callback: function callback($$v) {
        _vm.$set(_vm.formConfig, "search", $$v);
      },
      expression: "formConfig.search"
    }
  }), _c(VCheckbox, {
    attrs: {
      label: "Available products only",
      "hide-details": "auto"
    },
    model: {
      value: _vm.formConfig.isStockOnly,
      callback: function callback($$v) {
        _vm.$set(_vm.formConfig, "isStockOnly", $$v);
      },
      expression: "formConfig.isStockOnly"
    }
  }), _c("p", {
    staticClass: "mt-4 text-italic"
  }, [_vm._v(" The price list will be for this specific customer, and be compatible for any customer with the same configuration. "), _c("br"), _vm._v(" Prices will include all import and sales taxes. "), _c("br"), _vm._v(" * Except for french professionals, the prices will be exported without VAT * ")])], 1)] : _vm.isHolding(_vm.loggedUserData) ? [_vm.isLoadingUserList ? _c("div", {
    staticClass: "mb-6 text-italic text-sm"
  }, [_vm._v(" Loading required data. Please wait ")]) : !_vm.thirdPartyUserList.length ? _c("div", {
    staticClass: "mb-6"
  }, [_c("div", {
    staticClass: "text-warning text-bold"
  }, [_vm._v(" You do not yet have any customers to export a price list. ")]), _c("div", {
    staticClass: "button-end-page-container"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.openSendInvitationAsConsultantModal();
      }
    }
  }, [_vm._v(" Invite user(s) ")])], 1)]) : _vm._e(), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isLoadingUserList && _vm.thirdPartyUserList.length > 0,
      expression: "!isLoadingUserList && thirdPartyUserList.length > 0"
    }]
  }, [_c("div", [_vm._v("Please select the target for the price list")]), _c(VAutocomplete, {
    staticClass: "required",
    attrs: {
      items: _vm.thirdPartyUserList,
      "item-text": "full_name",
      "item-value": "id_user",
      "hide-selected": "",
      "hide-no-data": "",
      "no-data-text": _vm.isLoadingUserList ? "Loading user list" : _vm.thirdPartyUserList.length < 1 ? "No user is attached to your account" : "No match",
      "hide-details": "auto",
      label: _vm.isLoadingUserList ? "Loading users" : "Search for a specific customer",
      rules: [_vm.formRules.mustSelectValue],
      filter: _vm.filterVAutocomplete
    },
    model: {
      value: _vm.formConfig.userIdTarget,
      callback: function callback($$v) {
        _vm.$set(_vm.formConfig, "userIdTarget", $$v);
      },
      expression: "formConfig.userIdTarget"
    }
  }), _c(VAutocomplete, {
    staticClass: "v-text-field-no-label mt-2 --not-multi-style",
    attrs: {
      items: _vm.storageLocations,
      "item-value": "ids",
      "item-text": "name",
      label: ((_vm$formConfig$locati3 = _vm.formConfig.locations) === null || _vm$formConfig$locati3 === void 0 ? void 0 : _vm$formConfig$locati3.length) > 0 ? "Storage locations" : "All storage locations",
      "hide-details": "auto",
      "hide-no-data": "",
      "hide-selected": "",
      multiple: "",
      chips: "",
      "deletable-chips": "",
      clearable: ""
    },
    model: {
      value: _vm.formConfig.locations,
      callback: function callback($$v) {
        _vm.$set(_vm.formConfig, "locations", $$v);
      },
      expression: "formConfig.locations"
    }
  }), _c(VAutocomplete, {
    attrs: {
      items: _vm.listCountries,
      "item-text": "printable_name",
      "item-value": "id_country",
      label: ((_vm$listCountries3 = _vm.listCountries) === null || _vm$listCountries3 === void 0 ? void 0 : _vm$listCountries3.length) > 0 ? "Country & region of origin" : "Loading...",
      "hide-details": "auto",
      "hide-no-data": "",
      "hide-selected": "",
      clearable: "",
      filter: _vm.filterVAutocomplete
    },
    on: {
      "click:clear": function clickClear($event) {
        _vm.options = {
          smoothScroll: false
        };
      },
      change: function change($event) {
        return _vm.changeCountry();
      }
    },
    model: {
      value: _vm.formConfig.originCountryId,
      callback: function callback($$v) {
        _vm.$set(_vm.formConfig, "originCountryId", $$v);
      },
      expression: "formConfig.originCountryId"
    }
  }), _vm.formConfig.originCountryId > 0 ? _c(VAutocomplete, {
    attrs: {
      items: _vm.displayedListRegions,
      "item-text": "name",
      "item-value": "id",
      label: "Region",
      "hide-details": "auto",
      "hide-no-data": "",
      "hide-selected": "",
      clearable: "",
      filter: _vm.filterVAutocomplete
    },
    on: {
      "click:clear": function clickClear($event) {
        _vm.options = {
          smoothScroll: false
        };
      },
      change: function change($event) {
        return _vm.changeRegion();
      }
    },
    model: {
      value: _vm.formConfig.originRegionId,
      callback: function callback($$v) {
        _vm.$set(_vm.formConfig, "originRegionId", $$v);
      },
      expression: "formConfig.originRegionId"
    }
  }) : _vm._e(), _c(VAutocomplete, {
    staticClass: "v-text-field-no-label mt-4 --not-multi-style",
    attrs: {
      items: _vm.displayedListProducers,
      disabled: _vm.isLoadingProducers,
      "item-value": "id",
      "item-text": "name",
      label: ((_vm$formConfig$produc5 = _vm.formConfig.producersId) === null || _vm$formConfig$produc5 === void 0 ? void 0 : _vm$formConfig$produc5.length) > 0 ? "Producers" : "All producers",
      "hide-details": "auto",
      "hide-no-data": "",
      "hide-selected": "",
      clearable: "",
      multiple: "",
      chips: "",
      "deletable-chips": "",
      "search-input": _vm.winerySearchInput,
      filter: _vm.filterVAutocomplete
    },
    on: {
      "update:searchInput": function updateSearchInput($event) {
        _vm.winerySearchInput = $event;
      },
      "update:search-input": function updateSearchInput($event) {
        _vm.winerySearchInput = $event;
      },
      change: function change($event) {
        _vm.winerySearchInput = "";
      }
    },
    model: {
      value: _vm.formConfig.producersId,
      callback: function callback($$v) {
        _vm.$set(_vm.formConfig, "producersId", $$v);
      },
      expression: "formConfig.producersId"
    }
  }), _c(VAutocomplete, {
    staticClass: "v-text-field-no-label mt-4 --not-multi-style",
    attrs: {
      items: _vm.bottlings,
      "item-text": "text",
      "item-value": "value",
      label: ((_vm$formConfig$bottli3 = _vm.formConfig.bottlings) === null || _vm$formConfig$bottli3 === void 0 ? void 0 : _vm$formConfig$bottli3.length) > 0 ? "Bottlings" : "All bottlings",
      "hide-details": "auto",
      "hide-no-data": "",
      "hide-selected": "",
      clearable: "",
      multiple: "",
      chips: "",
      "deletable-chips": "",
      filter: _vm.filterVAutocomplete
    },
    model: {
      value: _vm.formConfig.bottlings,
      callback: function callback($$v) {
        _vm.$set(_vm.formConfig, "bottlings", $$v);
      },
      expression: "formConfig.bottlings"
    }
  }), !_vm.isSpiritsExport ? _c(VAutocomplete, {
    staticClass: "v-text-field-no-label mt-4 --not-multi-style",
    attrs: {
      items: _vm.getWineTypes,
      "item-text": "name",
      "item-value": "id",
      label: ((_vm$formConfig$produc6 = _vm.formConfig.productTypesId) === null || _vm$formConfig$produc6 === void 0 ? void 0 : _vm$formConfig$produc6.length) > 0 ? "Types" : "All types",
      "hide-details": "auto",
      "hide-no-data": "",
      "hide-selected": "",
      clearable: "",
      multiple: "",
      chips: "",
      "deletable-chips": "",
      filter: _vm.filterVAutocomplete
    },
    model: {
      value: _vm.formConfig.productTypesId,
      callback: function callback($$v) {
        _vm.$set(_vm.formConfig, "productTypesId", $$v);
      },
      expression: "formConfig.productTypesId"
    }
  }) : _vm._e(), _vm.canChoosePricePosting ? _c("div", {
    staticClass: "d-flex gap-5 align-center"
  }, [_c("div", {
    staticClass: "d-flex align-baseline gap-2"
  }, [_c(VIcon, {
    staticClass: "fa fa-greater-than-equal v-icon-price-range",
    attrs: {
      size: "0.65rem"
    }
  }), _c(VTextField, {
    attrs: {
      label: "Min price"
    },
    on: {
      keypress: _vm.filterDecimal2digitsKey
    },
    model: {
      value: _vm.formConfig.priceRange.min,
      callback: function callback($$v) {
        _vm.$set(_vm.formConfig.priceRange, "min", $$v);
      },
      expression: "formConfig.priceRange.min"
    }
  })], 1), _c("div", {
    staticClass: "d-flex align-baseline gap-2"
  }, [_c(VIcon, {
    staticClass: "fa fa-less-than-equal v-icon-price-range",
    attrs: {
      size: "0.65rem"
    }
  }), _c(VTextField, {
    attrs: {
      label: "Max price"
    },
    on: {
      keypress: _vm.filterDecimal2digitsKey
    },
    model: {
      value: _vm.formConfig.priceRange.max,
      callback: function callback($$v) {
        _vm.$set(_vm.formConfig.priceRange, "max", $$v);
      },
      expression: "formConfig.priceRange.max"
    }
  })], 1)]) : _vm._e(), _c(VTextField, {
    staticClass: "v-text-field-no-label mt-4",
    attrs: {
      label: "Filtering, match at least one of term",
      "hide-details": "auto"
    },
    model: {
      value: _vm.formConfig.search,
      callback: function callback($$v) {
        _vm.$set(_vm.formConfig, "search", $$v);
      },
      expression: "formConfig.search"
    }
  }), _c(VCheckbox, {
    attrs: {
      label: "Available products only",
      "hide-details": "auto"
    },
    model: {
      value: _vm.formConfig.isStockOnly,
      callback: function callback($$v) {
        _vm.$set(_vm.formConfig, "isStockOnly", $$v);
      },
      expression: "formConfig.isStockOnly"
    }
  }), _c("p", {
    staticClass: "mt-4 text-italic"
  }, [_vm._v(" The price list will be for this specific customer, and be compatible for any customer with the same configuration. "), _c("br"), _vm._v(" Prices will include all import and sales taxes. "), _c("br"), _vm._v(" * Except for french professionals, the prices will be exported without VAT * ")])], 1)] : [_c("div", [_vm._v("Please configure the price list")]), _c(VAutocomplete, {
    staticClass: "v-text-field-no-label mt-2 --not-multi-style",
    attrs: {
      items: _vm.storageLocations,
      "item-value": "ids",
      "item-text": "name",
      label: "All storage locations",
      solo: "",
      "hide-details": "auto",
      "hide-no-data": "",
      "hide-selected": "",
      multiple: "",
      chips: "",
      "deletable-chips": "",
      clearable: ""
    },
    model: {
      value: _vm.formConfig.locations,
      callback: function callback($$v) {
        _vm.$set(_vm.formConfig, "locations", $$v);
      },
      expression: "formConfig.locations"
    }
  }), _c(VCheckbox, {
    attrs: {
      label: "Available products only",
      "hide-details": "auto"
    },
    model: {
      value: _vm.formConfig.isStockOnly,
      callback: function callback($$v) {
        _vm.$set(_vm.formConfig, "isStockOnly", $$v);
      },
      expression: "formConfig.isStockOnly"
    }
  }), _c("p", {
    staticClass: "mt-4 text-italic"
  }, [_vm._v(" Prices will include all import and sales taxes. "), _c("br"), _vm._v(" * Except for french professionals, the prices will be exported without VAT * ")])], !_vm.isLoadingUserList ? _c("div", {
    staticClass: "button-end-page-container"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn",
    attrs: {
      rounded: "",
      disabled: !_vm.formConfig.valid
    },
    on: {
      click: function click($event) {
        return _vm.exportPriceList(_vm.exportTypesList.EXPORT_FILE.id);
      }
    }
  }, [_vm._v(" EXPORT FILE (≃ 15min) ")]), _c(VBtn, {
    staticClass: "dfwa-btn",
    attrs: {
      rounded: "",
      disabled: !_vm.formConfig.valid
    },
    on: {
      click: function click($event) {
        return _vm.exportPriceList(_vm.exportTypesList.MAIL_ATTACHMENT.id);
      }
    }
  }, [_vm._v(" RECEIVE ON MY EMAIL ")])], 1) : _vm._e()], 2)] : _vm.exportingStatus == _vm.exportingStatusList.EXPORTING.id ? [_vm._m(0), _c("div", {
    staticClass: "button-end-page-container"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn",
    attrs: {
      rounded: "",
      loading: true
    }
  }, [_vm._v("DOWNLOAD")])], 1)] : _vm.exportingStatus == _vm.exportingStatusList.EXPORT_COMPLETED.id ? [_vm._m(1), _c("div", {
    staticClass: "button-end-page-container"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.init();
      }
    }
  }, [_vm._v("Restart")]), _c(VBtn, {
    staticClass: "dfwa-btn",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.closeTab();
      }
    }
  }, [_vm._v("Close tab")])], 1)] : _vm.exportingStatus == _vm.exportingStatusList.WAITING_EMAIL.id ? [_c("div", {
    staticClass: "mt-4 text-smaller text-italic"
  }, [_c("p", [_vm._v("Your price list is in preparation.")]), _c("p", [_vm._v(" You will receive it in your mail box shortly" + _vm._s(_vm.userLogged.login ? " (" + _vm.userLogged.login + ")" : "") + ". ")]), _c("p", [_vm._v("Please consider checking your spam folder.")]), _c("p", [_vm._v("You can now close this browser tab.")])]), _c("div", {
    staticClass: "button-end-page-container"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.closeTab();
      }
    }
  }, [_vm._v("Close tab")])], 1)] : _vm.exportingStatus == _vm.exportingStatusList.ERROR.id ? [_vm._m(2), _c("div", {
    staticClass: "button-end-page-container"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.init();
      }
    }
  }, [_vm._v("Retry")]), _c(VBtn, {
    staticClass: "dfwa-btn",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.closeTab();
      }
    }
  }, [_vm._v("Close tab")])], 1)] : _vm._e()], 2), _c("SendInvitationAsConsultantModal", {
    ref: "SendInvitationAsConsultantModal"
  })], 1) : _vm._e();
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "mt-4 text-smaller text-italic"
  }, [_c("p", [_vm._v("Don't close this browser tab, the price list is in preparation.")]), _c("p", [_vm._v("The download will be automatically proposed when the file is ready.")]), _c("p", [_vm._v("You can continue your exploration clicking on the previous tab.")]), _c("p", [_vm._v("It may take a while. Please wait a moment.")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "mt-4 text-smaller text-italic"
  }, [_c("p", [_vm._v("You can now close this browser tab.")]), _c("p", [_vm._v("Thanks for your patience.")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "mt-4 text-smaller text-italic"
  }, [_c("p", [_vm._v("An unexpected error occurred.")]), _c("p", [_vm._v("Sorry for the inconvenience.")])]);
}];
render._withStripped = true;
export { render, staticRenderFns };